import React from "react";
import { node, objectOf, string } from "prop-types";
import classNames from "classnames";

import GridTableBody from "pages/_components/GridTable/GridTableBody";
import GridTableFooter from "pages/_components/GridTable/GridTableFooter";
import GridTableHeader from "pages/_components/GridTable/GridTableHeader";
import GridTableContainer from "pages/_components/GridTable/GridTableContainer";
import GridTableData from "pages/_components/GridTable/GridTableData";

const GridTable = ({ children, className, styles }) => (
    <div className={classNames("grid-table", className)} style={styles}>
        {children}
    </div>
);

GridTable.propTypes = {
    children: node.isRequired,
    className: string,
    styles: objectOf,
};

GridTable.defaultProps = {
    className: "",
    styles: {},
};

GridTable.Header = GridTableHeader;

GridTable.Body = GridTableBody;

GridTable.Container = GridTableContainer;

GridTable.Data = GridTableData;

GridTable.Footer = GridTableFooter;

export default GridTable;
